import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_LEGS_02: ReviewedLibraryIdentity[] = [
  {
    "id": "library-personal-s6-dumbbell-rdl",
    "name": "哑铃罗马尼亚硬拉",
    "group": "legs",
    "subCategory": "hamstrings",
    "equipment": "dumbbell",
    "pattern": "双腿哑铃髋铰链",
    "legacyIds": [
      "personal-s6-dumbbell-rdl"
    ],
    "sourceId": "course-20261008-home-03-05",
    "targetMuscles": [
      "腘绳肌",
      "臀大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s6-hip-flexor-raise",
    "name": "器械屈髋抬腿",
    "group": "legs",
    "subCategory": "hip-flexor",
    "equipment": "machine",
    "pattern": "器械单侧髋屈",
    "legacyIds": [
      "personal-s6-hip-flexor-raise"
    ],
    "sourceId": "course-20261008-personal-06-06",
    "targetMuscles": [
      "髋屈肌群",
      "股直肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-side-band-walk",
    "name": "弹力带侧向行走",
    "group": "legs",
    "subCategory": "glutes",
    "equipment": "resistance-band",
    "pattern": "负重髋外展侧向移动",
    "legacyIds": [
      "fanjue-side-band-walk"
    ],
    "sourceId": "course-20261008-fanjue-plan-15-03",
    "targetMuscles": [
      "臀中肌",
      "臀小肌"
    ],
    "evidence": "最新清单为正式，不按弹力带或原热身标记归激活"
  },
  {
    "id": "library-fanjue-wide-body-function",
    "name": "单腿绳索髋铰链",
    "group": "legs",
    "subCategory": "hamstrings",
    "equipment": "cable",
    "pattern": "单腿绳索髋铰链",
    "legacyIds": [
      "fanjue-wide-body-function"
    ],
    "sourceId": "course-20261008-fanjue-plan-15-06",
    "targetMuscles": [
      "腘绳肌",
      "臀大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-seated-leg-extension",
    "name": "坐姿器械腿屈伸",
    "group": "legs",
    "subCategory": "quadriceps",
    "equipment": "machine",
    "pattern": "坐姿器械膝伸",
    "legacyIds": [
      "fanjue-seated-leg-extension"
    ],
    "sourceId": "course-20261008-fanjue-plan-16-04",
    "targetMuscles": [
      "股四头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
